import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import CommonGrid from 'shared/commonGrid';
import { SelectionChangedEvent, ColDef, ColGroupDef } from '@ag-grid-enterprise/all-modules';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import { Filters } from 'data/filters/filters.types';
import FiltersListMenu from '../FiltersListMenu';

type Props = {
  data: Filters[];
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedFilters: Filters;
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onSelectionChanged: (event: SelectionChangedEvent) => void;
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onShowActionMenuItem: (menuId: string, data: Filters[]) => void
  onDeleteRow: () => void;
  onEdit: () => void;
}

const FiltersGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedFilters,
  onDeleteRow,
  onEdit,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onShowActionMenuItem,
  onSelectItemMenuAction,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }}>
      <CommonGrid
        createNewText={t('filter.dialog.title')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        actionMenuClass={FiltersListMenu}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        showActionMenuItem={onShowActionMenuItem}
        onActionMenuItemClick={onSelectItemMenuAction}
        lastUpdatedAt={lastUpdatedAt}
      >
        <FiltersListMenu
          selectedFilters={selectedFilters}
          hasPrivilegeToCreateNew={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default FiltersGrid;
